import {Box, Divider, Drawer, Grid, List, ListItem, ListItemButton, ListItemText} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useRecoilState} from "recoil";
import {userState} from "../../states/user/userAtom";
import {SidebarProfile} from "./SidebarProfile";
import {LoginImageAndButton} from "./LoginImageAndButton";
import {AlfyButton} from "../AlfyButton";
import {sidebarActiveState} from "../../states/common/layoutAtom";
import {useLogout} from "../../states/user/hooks";

export const AlfySidebar: React.FC = () => {
    // states
    const [sidebarActive, setSidebarActive] = useRecoilState(sidebarActiveState)
    const [user, setUser] = useRecoilState(userState)

    // hooks
    const navigate = useNavigate()
    const { logout } = useLogout()

    const handleClick = (path: string) => {
        navigate(path);
    }

    return (
        <Drawer open={sidebarActive} onClose={() => setSidebarActive(false)} anchor={'right'}>
            <Box sx={{width: 250}} role="presentation" onClick={() => setSidebarActive(false)}>
                <Box height={'48px'}/>
                <Grid container alignItems={"center"} flexDirection={"column"}>
                    <span style={{fontSize: "30px", fontWeight: 700, lineHeight: "42px"}}>약속잡기</span>
                    {user ? <SidebarProfile user={user}/> : <LoginImageAndButton/>}
                </Grid>
                {user
                    ? <Box marginX={'33px'} marginY={'33px'}><AlfyButton text={"약속 만들기"} onClick={() => navigate('/appointments/create')} /></Box>
                    : <Box height={'66px'}/>
                }
                {user &&
                  <>
                  <Box paddingLeft={'33px'}>
                    <span className={'description-text'}>내 정보</span>
                  </Box>
                    <List>
                      <ListItem key={'myPage'}>
                        <ListItemButton onClick={() => handleClick("/mypage")}>
                          <ListItemText primary={'마이페이지'} primaryTypographyProps={{fontWeight: 700}}/>
                        </ListItemButton>
                      </ListItem>
                      <ListItem key={'logout'}>
                        <ListItemButton onClick={ logout }>
                          <ListItemText primary={'로그아웃'} primaryTypographyProps={{fontWeight: 700}}/>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  </>
                }
                <Divider/>
                <Box height={"24px"}/>
                <Box paddingLeft={'33px'}>
                    <span className={'description-text'}>고객센터</span>
                </Box>
                <List>
                    <ListItem key={'notice'}>
                        <ListItemButton onClick={() => handleClick("/notice")}>
                            <ListItemText primary={'공지사항'} primaryTypographyProps={{fontWeight: 700}}/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={'contact'}>
                        {/* TODO 화면 개발 후 제대로 된 경로로 변경 */}
                        <ListItemButton onClick={() => handleClick("/")}>
                            <ListItemText primary={'문의하기'} primaryTypographyProps={{fontWeight: 700}}/>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </Drawer>
    )
};